export const SIZE: number = 15;